import { render, staticRenderFns } from "./site-sidebar.vue?vue&type=template&id=53e4f5da&scoped=true"
import script from "./site-sidebar.vue?vue&type=script&lang=js"
export * from "./site-sidebar.vue?vue&type=script&lang=js"
import style0 from "./site-sidebar.vue?vue&type=style&index=0&id=53e4f5da&prod&scoped=true&lang=css"
import style1 from "./site-sidebar.vue?vue&type=style&index=1&id=53e4f5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e4f5da",
  null
  
)

export default component.exports